import React, { useEffect, useState } from 'react'
import { GeoIpDataRecent } from '../../../services'
import { Navigation, MapPin } from 'lucide-react'

function GeoRecent() {
  const [geo, setGeo] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchGeo = async () => {
    try {
      setLoading(true)
      const res = await GeoIpDataRecent()
      setGeo(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchGeo()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-24 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-3 rounded-lg mr-4">
          <Navigation className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Recent Geographic Data</h2>
          <p className="text-sm text-gray-500">Latest geographic information from IPs</p>
        </div>
      </div>

      {geo.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <MapPin className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No recent geographic data found</p>
        </div>
      ) : (
        <div className="space-y-4">
          {geo.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-4 hover:bg-gradient-to-r hover:from-orange-50 hover:to-amber-50 transition-all duration-200 hover:border-orange-300"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-2">
                  <MapPin className="w-5 h-5 text-orange-500" />
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      {item.city || 'Unknown City'}, {item.region || 'Unknown Region'}
                    </h3>
                    <p className="text-sm text-gray-600">{item.country || 'Unknown Country'}</p>
                  </div>
                </div>
                <span className="text-xs text-gray-500">
                  {item.last_checked 
                    ? new Date(item.last_checked).toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })
                    : 'N/A'}
                </span>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                <div className="bg-gray-50 rounded-lg p-3">
                  <span className="text-gray-500 text-xs block mb-1">IP Address</span>
                  <p className="text-gray-800 font-mono text-sm">{item.ip || 'N/A'}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <span className="text-gray-500 text-xs block mb-1">Latitude</span>
                  <p className="text-gray-800 font-medium">
                    {item.latitude ? parseFloat(item.latitude).toFixed(4) : 'N/A'}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <span className="text-gray-500 text-xs block mb-1">Longitude</span>
                  <p className="text-gray-800 font-medium">
                    {item.longitude ? parseFloat(item.longitude).toFixed(4) : 'N/A'}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {geo.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200 text-center">
          <span className="text-sm text-gray-500">
            Showing {geo.length} recent geographic entries
          </span>
        </div>
      )}
    </div>
  )
}

export default GeoRecent